// ── Dominios de correo genéricos (2026-10-14) ────────────────────────────────
//
// gmail.com, outlook.com, icloud.com… no son una empresa: son la casilla de
// medio mundo. Una regla "para todo el dominio" sobre uno de ellos no habla de
// un remitente, habla de todos los que usan ese servicio.
//
// El caso que lo destapó: marcar como spam a un vendedor de SEO que escribía
// desde Gmail y elegir "todo el dominio" dejó a gmail.com como "Spam Sugerido".
// Desde ese momento, cada remitente nuevo de Gmail —un cliente incluido—
// entraba como spam sin pasar por el clasificador, y el buscador lo escondía.
// Pasó seis veces entre mayo y octubre de 2026.
//
// Se usa del lado del servidor (no se crean ni se aplican reglas de dominio
// sobre estos) y de la pantalla (no se ofrece la opción).
const GENERICOS = /^(gmail\.com|googlemail\.com|ymail\.com|rocketmail\.com|msn\.com|aol\.com|icloud\.com|me\.com|mac\.com|proton\.me|protonmail\.(com|ch)|pm\.me|zoho\.com|mail\.com|hey\.com|fastmail\.com|(yahoo|hotmail|outlook|live|gmx|yandex)\.[a-z]{2,}(\.[a-z]{2,})?)$/;
/** true si el dominio es un proveedor de correo de uso general, no una organización. */
export function esDominioDeCorreoGenerico(dominio) {
    return GENERICOS.test(dominio.trim().toLowerCase().replace(/^@/, ''));
}
//# sourceMappingURL=dominios-genericos.js.map